<template>
  <div v-if="organizationTemplate">
    <h4 class="card-title title-typography-color">
      Campos básicos
    </h4>
    <b-row>
      <b-col>
        <!--<b-form-group label-for="patientWithEmail">
          <b-form-checkbox v-model="organizationTemplate.patientWithEmail" size="lg" switch><span>Con email
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientEmail">
          <b-form-checkbox v-model="organizationTemplate.patientEmail" size="lg" switch><span>Email del
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientName">
          <b-form-checkbox v-model="organizationTemplate.patientName" size="lg" switch><span>Nombre del
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientSurname">
          <b-form-checkbox v-model="organizationTemplate.patientSurname" size="lg" switch><span>Apellido del
              paciente</span></b-form-checkbox>
        </b-form-group>-->
        <b-form-group label-for="patientDocumentType">
          <b-form-checkbox v-model="organizationTemplate.patientDocumentType" size="lg" switch><span>Tipo de documento del
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientIdentificationDocument">
          <b-form-checkbox v-model="organizationTemplate.patientIdentificationDocument" size="lg" switch><span>Documento
              de identificación del paciente</span></b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label-for="patientSpanishLanguage">
          <b-form-checkbox v-model="organizationTemplate.patientSpanishLanguage" size="lg" switch><span>Idioma español del
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientPhone">
          <b-form-checkbox v-model="organizationTemplate.patientPhone" size="lg" switch><span>Teléfono del
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientAddress">
          <b-form-checkbox v-model="organizationTemplate.patientAddress" size="lg" switch><span>Dirección del
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientCity">
          <b-form-checkbox v-model="organizationTemplate.patientCity" size="lg" switch><span>Ciudad del
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientPostalCode">
          <b-form-checkbox v-model="organizationTemplate.patientPostalCode" size="lg" switch><span>Código postal del
              paciente</span></b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label-for="patientCountry">
          <b-form-checkbox v-model="organizationTemplate.patientCountry" size="lg" switch><span>País del
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientTimeZone">
          <b-form-checkbox v-model="organizationTemplate.patientTimeZone" size="lg" switch><span>Zona horaria del
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientTown">
          <b-form-checkbox v-model="organizationTemplate.patientTown" size="lg" switch><span>Población
              paciente</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientPicture">
          <b-form-checkbox v-model="organizationTemplate.patientPicture" size="lg" switch><span>Foto perfil</span></b-form-checkbox>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group label-for="patientNameMother">
          <b-form-checkbox v-model="organizationTemplate.patientNameMother" size="lg" switch><span>Nombre de la
              madre</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientLastnameMother">
          <b-form-checkbox v-model="organizationTemplate.patientLastnameMother" size="lg" switch><span>Apellido de la
              madre</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientEmailMother">
          <b-form-checkbox v-model="organizationTemplate.patientEmailMother" size="lg" switch><span>Email de la
              madre</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientDocumentMother">
          <b-form-checkbox v-model="organizationTemplate.patientDocumentMother" size="lg" switch><span>Documento de
              identificación de la madre</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientPhoneMother">
          <b-form-checkbox v-model="organizationTemplate.patientPhoneMother" size="lg" switch><span>Teléfono de la
              madre</span></b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label-for="patientNameFather">
          <b-form-checkbox v-model="organizationTemplate.patientNameFather" size="lg" switch><span>Nombre del
              padre</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientLastnameFather">
          <b-form-checkbox v-model="organizationTemplate.patientLastnameFather" size="lg" switch><span>Apellido del
              padre</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientEmailFather">
          <b-form-checkbox v-model="organizationTemplate.patientEmailFather" size="lg" switch><span>Email del
              padre</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientDocumentFather">
          <b-form-checkbox v-model="organizationTemplate.patientDocumentFather" size="lg" switch><span>Documento de
              identificación del padre</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientPhoneFather">
          <b-form-checkbox v-model="organizationTemplate.patientPhoneFather" size="lg" switch><span>Teléfono del
              padre</span></b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label-for="patientFirstDate">
          <b-form-checkbox v-model="organizationTemplate.patientFirstDate" size="lg" switch><span>Primera
              fecha</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientStudies">
          <b-form-checkbox v-model="organizationTemplate.patientStudies" size="lg"
            switch><span>Estudios</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientDerived">
          <b-form-checkbox v-model="organizationTemplate.patientDerived" size="lg"
            switch><span>Derivado</span></b-form-checkbox>
        </b-form-group>
        <b-form-group label-for="patientMaritalStatus">
          <b-form-checkbox v-model="organizationTemplate.patientMaritalStatus" size="lg" switch><span>Estado
              civil</span></b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <h4 class="card-title title-typography-color">
      Campos adicionales
    </h4>
    <div class="test-survey-builder" v-if="tabs && tabs[0]">
      <QuestionsView :questions="tabs[0].questionsList" :readOnly="false" />
      <div v-if="addQuestion">
        <SurveyBuilder :options="sampleQuestion" :tab="0" />
      </div>
      <div class="text-right mt-2">
        <b-button variant="success" v-on:click="addNewQuestion()">
          Nuevo campo
        </b-button>
      </div>
    </div>
    <h4 class="card-title title-typography-color">
      Funcionalidades
    </h4>
    <b-row>
      <b-col>
        <b-form-group label-for="patientProfessionalOwner">
          <b-form-checkbox v-model="organizationTemplate.patientProfessionalOwner" size="lg" switch><span>Asignar terapeutas a paciente</span></b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { xray } from "../../config/pluginInit";

import Survey from "../../json/Survey";

import SurveyBuilder from "../../components/survey/SurveyBuilderTemplate";
import QuestionsView from "../../components/survey/QuestionsTemplateView";

import organizationTemplateService from "../../services/organizationTemplate";
import utilsService from "../../services/utils"
import questionaryService from "../../services/questionary";
import professionalService from "../../services/professional";

export default {
  name: "PreferencesTemplates",
  mounted() {
    xray.index();
    this.get();
    this.initComponetsTemplates();
  },
  methods: {
    getTemplate(uuid) {
      let self = this;


      professionalService.findQuestionary(this.professional, uuid).then(
        (response) => {
          if (response) {
            self.uuid = response.data.uuid;
            self.name = response.data.name;
            self.tabs = response.data.tabs;
          }
        }).catch(
          (error) => {
            utilsService.auditErrorFrontent({
              info: "professionalService.findQuestionary",
              module: "view-pages-professional-contact-survey",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                professional: this.professional, uuid: uuid
              })
            });
          }
        );
    },
    save() {
      let self = this;

      let data = {
        uuid: this.uuid,
        numCol: 12,
        selected: this.selected,
        name: "PATIENT_TEMPLATE",
        professional: localStorage.getItem("userId"),
        template: true,
        tabs: this.tabs,
        type: "ORGANIZATION_PATIENT",
      };

      this.$awn.asyncBlock(
        questionaryService.saveTab(data),
        (response) => {
          if (response) {
            self.organizationTemplate.patientTemplate = response.data.uuid;
            self.update();
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_SURVEY", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Survey.notification.descSaveTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "questionaryService.saveTab",
            module: "view-pages-professional-contact-survey",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    async get() {
      let self = this;

      organizationTemplateService.findTemplate(
        localStorage.getItem("organizationId")
      ).then(
        (response) => {
          if (response) {
            self.organizationTemplate = response.data;
            if (self.organizationTemplate.patientTemplate) {
              self.getTemplate(self.organizationTemplate.patientTemplate);
            } else {
              self.createTab();
            }
          }
        }).catch(
          (error) => {
            utilsService.auditErrorFrontent({
              info: "organizationTemplateService.findTemplate",
              module: "component-organization-preferencesTemplatesPatient",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                organizationId: localStorage.getItem("organizationId")
              }),
            });
          }
        );
    },
    async update() {
      let self = this;

      this.$awn.asyncBlock(
        organizationTemplateService.updateTemplate(this.organizationTemplate
        ),
        (response) => {
          if (response) {
            self.organizationTemplate = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationTemplateService.findTemplate",
            module: "component-organization-preferencesTemplatesPatient",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            }),
          });
        },
        " "
      );
    },
    async initComponetsTemplates() {
      this.$root.$on("change-colums", (columns) => {
        this.numCol = columns;
      });
      this.$root.$on("add-update-question", (q, tab) => {
        this.updateQuestionsList(q, tab);
      });
    },
    createTab() {
      let tab = {
        name: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Survey.createdTab"
        ),
        questionsList: [],
      };

      this.tabs.push(tab);
    },
    updateQuestionsList(question, tab) {
      if (this.tabs[tab].questionsList === null) {
        this.tabs[tab].questionsList = [];
      }
      let sequenceIndex = this.tabs[tab].questionsList.length + 1;
      question.sequence = sequenceIndex;
      const questionIndex = this.tabs[tab].questionsList.findIndex(
        (x) => x.uuid === question.uuid
      );
      if (questionIndex >= 0) {
        this.tabs[tab].questionsList.splice(questionIndex, 1, question);
      } else {
        this.tabs[tab].questionsList.push(JSON.parse(JSON.stringify(question)));
      }
      this.addQuestion = false;
      this.$root.$emit("selected-question", null);
    },
    addNewQuestion() {
      this.sampleQuestion = JSON.parse(JSON.stringify(Survey));
      this.sampleQuestion.uuid = this.getGUID();
      this.addQuestion = true;
    },
    getGUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }

      return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;
    },
  },
  computed: {},
  data() {
    return { organizationTemplate: undefined, tabs: [], addQuestion: false, uuid: undefined, numCol: 12, professional: localStorage.getItem("userId") };
  },
  components: { SurveyBuilder, QuestionsView },
};
</script>